// extracted by mini-css-extract-plugin
export var header = "_up-1";
export var maskBottom = "_up-6";
export var maskMiddle = "_up-7";
export var maskTop = "_up-5";
export var root = "_up-0";
export var scrollDownButton = "_up-3";
export var scrollDownButtonHidden = "_up-4";
export var viewport = "_up-2";